export default {"src":"/_next/static/media/partner_cardBlur.cd992cdd.svg","height":305,"width":277,"blurWidth":0,"blurHeight":0};